import { Box, LinearProgress, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 */
/**
 * Loading component with a slim indeterminate progress bar.
 *
 * @param {Object} props
 * @param {MUIColor} props.color - Bar and text color.
 * @param {String} props.waitingMessage - Message to show while waiting.
 * @param {String} [props.width="220px"] - Width of the bar.
 * @param {String} [props.padding="20px"] - Padding around the component.
 * @returns {JSX.Element} The DataLoadingBar component
 */
const DataLoadingBar = ( { color = 'primary', waitingMessage, width = "100%", padding = "20px" } ) => {
    return (
        <Box padding={padding} display="flex" flexDirection="column" gap="8px" alignItems="center" maxWidth="800px" width={width}>
            {waitingMessage && <Typography fontSize="14px" fontWeight="500" color={color} variant='caption'>{waitingMessage}</Typography>}
            <LinearProgress color={color} sx={{ width: "100%", borderRadius: "10px", height: "6px" }} />
        </Box>
    )
}

DataLoadingBar.propTypes = {
    color: PropTypes.string,
    waitingMessage: PropTypes.string,
    width: PropTypes.string,
    padding: PropTypes.string,
}

export default DataLoadingBar
